import React, { useEffect } from 'react';
import Banner from './banner';
import Welcome from './welcome';
import Theme from './theme';
import Speakers from './speakers';
import Dates from './dates';

function Home() {
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Banner />
      <Welcome />
      <Theme />
      <Speakers />
      <Dates />
    </React.Fragment>
  )
}

export default Home